import { useEffect, useState } from 'react';

export function useBumperAd({ disabled = false, bumperDelay = 15000 } = {}) {
    const [bumperAdDisabled, setBumperAdDisabled] = useState(() =>
        disabled ? new Date().getTime() : null,
    );
    if (disabled && bumperAdDisabled === null) {
        setBumperAdDisabled(new Date().getTime());
    }
    useEffect(() => {
        if (bumperAdDisabled === null) {
            return () => {};
        }
        const timeout = setTimeout(
            () => {
                setBumperAdDisabled(null);
            },
            Math.max(bumperDelay - (new Date().getTime() - bumperAdDisabled), 0),
        );
        return () => clearTimeout(timeout);
    }, [bumperAdDisabled]);

    return {
        active: !disabled && bumperAdDisabled === null,
        disable: () => setBumperAdDisabled(new Date().getTime()),
    };
}
